module.exports = __webpack_public_path__ + "img/VM24_0994.0a7242da.jpg";